import { cn } from "@/shared/utils/cn";
import { PropsWithChildren } from "react";
export interface SelectBoxProps extends PropsWithChildren {
  active: boolean;
  onClick: () => void;
}

const SelectBox = ({ active, onClick, children }: SelectBoxProps) => {
  return (
    <div
      onClick={onClick}
      className={cn(
        "overflow-hidden whitespace-nowrap mb-6 rounded-1 cursor-pointer p-6 text-ellipsis",
        active ? "bg-primary font-semibold text-white" : "bg-grey text-text"
      )}
    >
      {children}
    </div>
  );
};

export default SelectBox;
